import styled, { css } from 'styled-components';

import {
  motionTimeS,
  scale070,
  scale100,
  scale130,
  scale180,
  spaceS,
  spaceXS,
} from '@xing-com/tokens';

export const socialBarTransitionName = 'social-bar-animation';
export const socialBarAnimationDuration = motionTimeS;

// *** Base ***
const baseSocialBar = css`
  display: flex;
  flex-direction: column;
  height: ${scale130};
  justify-content: flex-end;
  transition: height ${socialBarAnimationDuration} linear;
  z-index: 1;

  & button,
  & a,
  & div {
    font-size: ${scale070};
    font-weight: normal;
    line-height: 1;
  }

  /* Social Bar Animation */
  &.${socialBarTransitionName}-enter {
    height: 45px;
  }

  &.${socialBarTransitionName}-enter-active {
    height: 55px;
  }

  &.${socialBarTransitionName}-enter-done {
    height: ${scale180};
  }

  &.${socialBarTransitionName}-exit {
    height: ${scale180};
  }

  &.${socialBarTransitionName}-exit-active {
    height: calc(${scale130} + ${scale070});
  }

  .${socialBarTransitionName}-exit-done {
    height: ${scale130};
  }
`;

const baseSocialReactions = css`
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: ${spaceS};
  width: 100%;

  & button,
  & a,
  & div {
    padding: 0;
  }
`;

const baseSocialReactionsLeft = css`
  align-items: center;
  display: flex;
  flex: 1;

  & button,
  & a {
    flex: 1;
    height: initial;
    min-width: initial;
    margin-right: ${spaceS};

    > div span:nth-child(1) {
      margin-right: ${spaceXS};
    }
  }
`;

// *** Components ***
const SocialBar = styled.div`
  ${baseSocialBar}
`;

const SocialReactions = styled.div`
  ${baseSocialReactions}
`;

const SocialReactionsLeft = styled.div<{ compact?: boolean }>`
  ${baseSocialReactionsLeft};
  ${({ compact }) =>
    compact &&
    css`
      & button,
      & a {
        margin-right: ${scale100};
      }
    `};
`;

export const Styled = {
  SocialBar,
  SocialReactions,
  SocialReactionsLeft,
};
